"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const form_field_element_1 = __importDefault(require("components/form/form-field-element"));
const utils_1 = require("core/utils");
const React = __importStar(require("react"));
const redux_form_1 = require("redux-form");
const private_checkbox_1 = __importDefault(require("./private-checkbox"));
// TODO: Create props type
class ProfileFormFields extends React.Component {
    getGenderOptions() {
        return [
            { text: 'No Selection', value: '' },
            { text: 'Male', value: 'male' },
            { text: 'Female', value: 'female' },
        ];
    }
    render() {
        const { change } = this.props;
        const birthdatePickerProps = {
            showMonthDropdown: true,
            showYearDropdown: true,
            maxDate: (0, utils_1.todayMoment)(),
        };
        return (React.createElement("div", { className: "Panel-cell Grid-cell u-sizeFull u-xs-size16of24 u-sm-size18of24" },
            React.createElement("div", { id: "profile-settings-form", className: "Grid Grid--withGutter" },
                React.createElement("div", { className: "Grid-cell u-sizeFull u-sm-size1of2 u-spaceBottomSm" },
                    React.createElement("label", { className: "FieldGroup-label", htmlFor: "firstName" }, "First Name"),
                    React.createElement(redux_form_1.Field, { id: "firstName", name: "firstName", component: form_field_element_1.default, type: "text", maxLength: 40 })),
                React.createElement("div", { className: "Grid-cell u-sizeFull u-sm-size1of2 u-spaceBottomSm" },
                    React.createElement("label", { className: "FieldGroup-label", htmlFor: "lastName" }, "Last Name"),
                    React.createElement(redux_form_1.Field, { id: "lastName", name: "lastName", component: form_field_element_1.default, type: "text", maxLength: 40 })),
                React.createElement("div", { className: "Grid-cell u-sizeFull u-sm-size1of2" },
                    React.createElement("label", { className: "FieldGroup-label", htmlFor: "birthdate" }, "Birthday"),
                    React.createElement(redux_form_1.Field, { id: "birthdate", name: "birthdate", component: form_field_element_1.default, type: "date", dateProps: birthdatePickerProps, change: change, fieldGroupClass: "u-spaceBottomSm" }),
                    React.createElement(private_checkbox_1.default, { name: "isAgeHidden", isAge: true })),
                React.createElement("div", { className: "Grid-cell u-sizeFull u-sm-size1of2 u-padTopMd u-sm-padTopNone" },
                    React.createElement("label", { className: "FieldGroup-label", htmlFor: "gender" }, "Gender"),
                    React.createElement(redux_form_1.Field, { id: "gender", component: form_field_element_1.default, type: "select", name: "gender", className: "gender", options: this.getGenderOptions() })))));
    }
}
exports.default = ProfileFormFields;
